export default __webpack_public_path__ + "ffd980477169735489b0f101b3ae01e9.png";